import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styles from "./sharedData.module.scss";
import { useEffect, useState } from "react";
import SharedDataForm from "./SharedDataForm";
import ViewShareddata from "./ViewSharedData";
import { useSelector, useDispatch } from "react-redux";
import {
  getSharedDataUserInputs,
  getRecipeTemplate,
  getRecipeData,
  getSdUserData,
  getLookupOptions,
  setProductData,
  setFormInputValues,
  setExistingInputValues,
  getLookupOptionsData,
  getAvailableSdInputStates,
  sdStates,
  getProductInfo,
  getProductInfoById,
  resetFormInputValues,
} from "./sharedDataSlice";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { Helmet } from "react-helmet";

const SharedData = ({ action }) => {
  const [searchParam, _] = useSearchParams();
  const [inputFields, setInputFields] = useState([]);
  const [currentSdState, setCurrentSdState] = useState(null);
  const [availableSdStates, setAvailableSdStates] = useState([]);
  const { state } = useLocation();
  const sdUserInputs = useSelector(getSdUserData);
  const recipeTemplate = useSelector(getRecipeData);
  const lookUpData = useSelector(getLookupOptionsData);
  const dispatch = useDispatch();
  const productInfo = useSelector(getProductInfo);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetFormInputValues()); // Clear stale values immediately on mount
    const loadProductInfo = async () => {
      try {
        await dispatch(getProductInfoById(searchParam.get("id")));
      } catch (e) {
        navigate("/products");
      }
    };

    loadProductInfo();
    return () => {
      dispatch(setProductData({}));
      dispatch(resetFormInputValues());
    };
  }, []);

  useEffect(() => {
    if (Object.keys(productInfo).length > 0) {
      findCurrentAndAvailableState();
      dispatch(setProductData(productInfo));
      dispatch(getLookupOptions());
      dispatch(getAvailableSdInputStates());
    }
  }, [productInfo]);

  useEffect(() => {
    if (
      Object.keys(lookUpData).length > 0 &&
      Object.keys(productInfo).length > 0
    ) {
      dispatch(getRecipeTemplate(productInfo.Recipe));
    }
  }, [lookUpData, productInfo]);

  useEffect(() => {
    if (currentSdState) {
      dispatch(getSharedDataUserInputs(currentSdState));
    }
  }, [currentSdState]);

  useEffect(() => {
    if (sdUserInputs.length > 0) {
      dispatch(setFormInputValues(JSON.parse(sdUserInputs[0].Input)));
      dispatch(setExistingInputValues(JSON.parse(sdUserInputs[0].Input)));
    }
    // else {
    //   // dispatch(setFormInputValues({}));
    //   // dispatch(setExistingInputValues({}));
    // }
  }, [sdUserInputs, currentSdState]);

  useEffect(() => {
    if (recipeTemplate.length > 0) {
      const inputs = recipeTemplate.filter((item) => item.type === "input");
      setInputFields(inputs);
    }
  }, [recipeTemplate]);

  const findCurrentAndAvailableState = () => {
    if (productInfo.State === sdStates.production) {
      setCurrentSdState(sdStates.production);
      setAvailableSdStates([sdStates.production, sdStates.staging]);
    } else if (productInfo.State === sdStates.staging) {
      setCurrentSdState(sdStates.staging);
      setAvailableSdStates([sdStates.staging]);
    } else if (productInfo.State === sdStates.preProd) {
      setCurrentSdState(sdStates.preProd);
      setAvailableSdStates([sdStates.preProd]);
    } else {
      setCurrentSdState(sdStates.draft);
      setAvailableSdStates([sdStates.draft]);
    }
  };

  const getPageName = () => {
    switch (action) {
      case "createSD":
        return "Create Shared Data";
      case "updateSD":
        return "Update Shared Data";
      case "viewSD":
        return "View Shared Data";
      default:
        return "";
    }
  };

  const getPageTitle = () => {
    switch (action) {
      case "createSD":
        return "Shared Data Portal | Create Shared Data";
      case "updateSD":
        return "Shared Data Portal | Update Shared Data";
      case "viewSD":
        return "Shared Data Portal | View Shared Data";
      default:
        return "";
    }
  };

  return (
    <>
      <div className={styles.body}>
        <Helmet>
          <title>{getPageTitle()}</title>
        </Helmet>
        <div className={styles.pageNameContainer}>
          <div className={styles.pageName}>{getPageName()}</div>
          <div className={styles.breadcrumbs}>
            <Breadcrumbs />
          </div>
        </div>
        <div className={styles.productDetailsCard}>
          <div className={styles.productDetailsName}>Product Details</div>
          <div className={styles.productDetails}>
            <div>
              Model Number: <span>{productInfo.ModelNumber}</span>
            </div>
            <div>
              Product Family: <span>{productInfo.Family}</span>
            </div>
            <div>
              Product Sub Category: <span>{productInfo.SubCategory}</span>
            </div>
            <div>
              Shared Data:{" "}
              <span>
                {productInfo.SdAvailable ? "Available" : "Not Available"}
              </span>
            </div>
            <div>
              Shared Data Revision Version:{" "}
              <span>{productInfo.ProductionVersion}</span>
            </div>
            <div>
              Bluetooth Enabled:{" "}
              <span>{productInfo.BtEnabled ? "Yes" : "No"}</span>
            </div>
            <div>
              Control ID: <span>{productInfo.ControlId}</span>
            </div>
            <div>
              Control Type: <span>{productInfo.ControlType}</span>
            </div>
            <div>
              Selected Recipe: <span>{productInfo.Recipe}</span>
            </div>
            <div>
              State:{" "}
              <span className={styles.state}>
                {productInfo.State ? productInfo.State : "--"}
              </span>
            </div>
          </div>
            {productInfo.Category && (
            <div className={styles.productDetailsCardSecond}>
              <div className={styles.productDetailsNameSmall}>Product Category Details</div>
              <div className={styles.productDetails}>
                <div className={styles.productDetailsCardSecondText}>
                  {typeof productInfo.Category === 'string' ? (
                    (() => {
                      try {
                        const categoryObj = JSON.parse(productInfo.Category);
                        return Object.entries(categoryObj).map(([key, value]) => (
                          <div key={key} style={{ marginBottom: '0.5rem' }}>
                            {key}: <span>{value}</span>
                          </div>
                        ));
                      } catch (error) {
                        return <div>{productInfo.Category}</div>;
                      }
                    })()
                  ) : (
                    Object.entries(productInfo.Category).map(([key, value]) => (
                      <div key={key} style={{ marginBottom: '0.5rem' }}>
                        {key}: <span>{value}</span>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          )}
           {/* Comments Box */}
          {sdUserInputs.length > 0 && sdUserInputs[0].ReasonForChange && (
            <div className={styles.productDetailsCardSecond}>
              <div className={styles.productDetailsNameSmall}>Comments</div>
              <div className={styles.productDetails}>
                <div className={styles.productDetailsCardSecondText}>
                  <span>{(() => {
                    let rfc = sdUserInputs[0].ReasonForChange;
                    if (typeof rfc === 'string') {
                      try { rfc = JSON.parse(rfc); } catch {}
                    }
                    return (rfc && rfc.comment) || (typeof rfc === 'string' ? rfc : '');
                  })()}</span>
                </div>
              </div>
            </div>
          )}
        </div>
        

        {currentSdState && (
          <div className={styles.sharedDataFormCard}>
            {(action === "createSD" || action === "updateSD") &&
              inputFields.length > 0 && (
                <SharedDataForm
                  fields={inputFields}
                  currentSdState={currentSdState}
                  availableSdStates={availableSdStates}
                  action={action}
                  setSdState={setCurrentSdState}
                />
              )}
            {action === "viewSD" &&
              inputFields.length > 0 &&
              sdUserInputs.length > 0 && (
                <ViewShareddata
                  inputFields={inputFields}
                  currentSdState={currentSdState}
                  availableSdStates={availableSdStates}
                  action={action}
                  setSdState={setCurrentSdState}
                />
              )}
          </div>
        )}
      </div>
    </>
  );
};

export default SharedData;
